import { observer } from "mobx-react-lite";
import SmartAppStep from "../../components/apps/SmartAppStep";
import { Grid, Box} from "@mui/material";
import RunOcrServiceButton from "../../components/buttons/run-ocr-service-button/RunOcrServiceButton";
import Player from "../../components/video-player/Player";
import VideoPlayer from "e.sic-platform.webclient/src/components/video-player/VideoPlayer";
import OcrInput from "./components/OcrInput";
import InspectionReport from 'e.sic-platform.webclient/src/components/inspection/InspectionReport';
import SmartAppBase from "../../components/apps/SmartAppBase";
import { FileStates } from "e.sic-platform.webclient/src/services/shop/ShopHistoryStorage";
import { Assignment } from "@mui/icons-material";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';
import PdfButton from "../../components/buttons/app-action-buttons/PdfButton";
import CsvButton from "../../components/buttons/app-action-buttons/CsvButton";
import ExportXmlButton from "../../components/buttons/app-action-buttons/ExportXmlButton";
import { ocrApp } from "../../services/apps/SmartApps";
import LabelingInfo from "e.sic-platform.webclient/src/components/labeling/LabelingInfo";
import { useCallback, useEffect } from "react";

export default observer(function OcrServicePage() {
  const ocrService = ocrApp.services.ocrService!;
  const {themeClass} = useThemeService();

  const startOcr = useCallback(async () => {
    await ocrService.startService();
    await ocrService.load();
  }, [ocrService])

  useEffect(() => {
    ocrApp.toggleCollapsed(true)
  }, []);

  if (ocrService.ocrSuccessful) ocrApp.setStep(3);

  return (
    <SmartAppBase 
      appStorage={ocrApp}
      icon={{
        svg: Assignment,
        textKey: "RunOcrServiceButton.run",
        className: themeClass(["icon-custom"]),
      }}
      actionBar={<>
        <PdfButton disabled={!ocrService.ocrSuccessful || ocrService.pdfLoading} onClick={ocrService.downloadPdf}/>
        <CsvButton disabled={!ocrService.ocrSuccessful || ocrService.isLoading} onClick={ocrService.downloadCsv}/>
        <ExportXmlButton disabled={!ocrService.ocrSuccessful || ocrService.isLoading} onExportDwa={ocrService.downloadDwa} onExportIsybau={ocrService.downloadIsybau}/>
      </>}
    >
      <SmartAppStep
        step={2}
        titleKey="ocrService.labelVideoAreas.title"
        descriptionKey="ocrService.labelVideoAreas.description"
        visible={ocrService?.video !== undefined && !(ocrService.status === FileStates.Success)}
        appStorage={ocrApp}
      >
        <Grid container rowSpacing={1}>
          <Grid item xs={12} sm={12} xl={8}>
            {ocrService.video !== undefined && (
              <Player service={ocrService}>
                {ocrService?.video!.isAvailable && <VideoPlayer enableControls />}
                <LabelingInfo type="flow" clickType="button" iconSx= {{position: "absolute", top: 8, right: 8}} />
              </Player>            
            )}
          </Grid>
          <Grid container xs={12} sm={12} xl={8} sx={{mt: 1}}>
            <OcrInput ocrService={ocrService}/>
          </Grid>
          <Grid item xs={12} sm={12} xl={8} className="centered">
            <RunOcrServiceButton
              onClick={startOcr}
              disabled={!ocrService.inputProvided}
            />
          </Grid>
        </Grid>
      </SmartAppStep>

      <SmartAppStep
        step={3}
        visible={ocrService.video !== undefined && ocrService.video.isConverted}
        titleKey="ocrService.inspection-report.title"
        descriptionKey="videoAnalysis.inspection-report.description"
        appStorage={ocrApp}
      >
        <Grid container xs={12}>
          <Grid item xs={12} className="centered">
            <InspectionReport fileId={ocrService.fileId!} onFinished={ocrService.onServiceFinished} ocr={ocrService}>
              {ocrService.video !== undefined && (
                <Player service={ocrService}>
                  {ocrService?.video!.isAvailable && (
                    <VideoPlayer enableControls />
                  )}
                </Player>
              )}
            </InspectionReport>
          </Grid>
        </Grid>
      </SmartAppStep>
    </SmartAppBase>
  );
});
